import { Component, OnInit } from '@angular/core';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';
import { ReleaseRetrievalService } from 'src/app/services/apiHandler/release-retrieval/release-retrieval.service';
import { GlobalService } from 'src/app/services/helper/global-helper';
import { RoleService } from 'src/app/services/helper/role-handling-helper';

const FRONTEND = 'Remote Diagnose Frontend';
const BACKEND = 'Remote Diagnose Backend';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit{


  public connected: boolean = false;
  open: boolean = false;
  frontendRelease: any;
  frontendVersion = '';
  frontendReleaseNotes: any;
  backendRelease: any;
  backendVersion = '';
  backendReleaseNotes: any;
  loaded: boolean = false;

  constructor(public roleService: RoleService, private global: GlobalService, private gwConnection: GatewayConnectionService, private releaseRetrievalService: ReleaseRetrievalService){
    this.global.variables.subscribe({
      next: newValue => {this.connected = newValue.connected;}
    });
  }

  ngOnInit(): void {
    this.loaded = false;
      this.getReleaseNotes(FRONTEND).then(() => {
        this.getReleaseNotes(BACKEND).then(() => {
          this.loaded = true;
        });
      });
  }

  private getReleaseNotes(component: string): Promise<void> {
    return new Promise((resolve) => {
      this.releaseRetrievalService.getComponentNotes(component).subscribe((resp) => {
        let allNotes = JSON.parse(JSON.stringify(resp.body));
        let latestReleaseNotes = allNotes.versions[0];
        this.extractReleaseNotes(component, latestReleaseNotes);
        resolve();
      });
    });
  }

  private extractReleaseNotes(component: string, notes: any) {
    if(component.includes('Frontend')){
      this.frontendVersion = notes.versionTag;
      this.frontendReleaseNotes = notes.versionNotes;
    } else if(component.includes('Backend')) {
      this.backendVersion = notes.versionTag;
      this.backendReleaseNotes = notes.versionNotes;
    }
  }

  public openRelease() {
    this.open = !this.open;
  }

}
